// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xb-1";
export var printerIcon = "_xb-0";